<script lang="ts">
  interface Properties {
    message: string;
  }

  const { message }: Properties = $props();
</script>

<!-- Muted placeholder shown when a list/panel has no data. -->
<p class="empty-state">{message}</p>

<style>
  .empty-state {
    color: var(--color-fg-muted);
    font-size: var(--font-size-sm);
    padding: var(--space-md);
    text-align: center;
  }
</style>
